var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"Catalog"}},[(_vm.data.section == 'home')?_c('Home'):_vm._e(),(_vm.data.product && _vm.data.view != 'pls')?_c('Product'):(_vm.data.product && _vm.data.view == 'pls')?_c('ProductPLS'):_vm._e(),(_vm.data.section == 'view')?_c('ProductsView'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }